// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kxrduwrurqjvouiqobyc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt4cmR1d3J1cnFqdm91aXFvYnljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUwMTEzOTcsImV4cCI6MjA2MDU4NzM5N30.p8YjQNTTWTZ91lzhLgyUfFKwFnY8LrSyuiat9vh2zYY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);